export default "__VITE_ASSET__fNOYy8sn__"